module.exports = __webpack_public_path__ + "static/015-79c33b2ac1755d0ea7fd35a4b67716e6.jpg";